<template>
  <div class="flex flex-wrap items-center space-x-2">
    <formula-equation :formula="formula" :level="[]" />
    <formula-input-toggle open @select="appendFormulaItem" />
  </div>
</template>

<script lang="ts" setup>
import { useAttributeBuilderStore } from "@/stores/customAttributeBuilder";

import FormulaEquation from "@/components/customAttributes/formula/FormulaEquation.vue";
import FormulaInputToggle from "@/components/customAttributes/formula/FormulaInputToggle.vue";

import type { CustomAttributeFormula } from "@/models/customAttributes/customAttribute";
import type { PropType } from "vue";

defineProps({
  formula: {
    type: Object as PropType<CustomAttributeFormula>,
    required: true,
  },
});

const { appendFormulaItem } = useAttributeBuilderStore();
</script>
